<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("rate_detail_txt") }}</h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.addwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.adddate}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.editwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.editdate}}</p>
                    </div>

                    
                    
                  </div>

                </div>

                <div class="card-body">

       
                  <div class="row mb-3">
                    <div class="col">
											<label class="form-label">{{$t('customerGroup')}}</label>
											<input
                          type="text"
                          class="form-control"
                          id="customerGroup"
                          :placeholder="$t('customerGroup')"
                          v-model="forms.customerGroup"
                          disabled
                        />
										</div>
										<div class="col-md-6">
											<label class="form-label">{{
                          $t('customerSAPCode')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="customerSAPCode"
                          :placeholder="$t('customerSAPCode')"
                          v-model="forms.customerSAPCode"
                          disabled
                        />
										</div>
                  </div>

       
                  <div class="row mb-3">
                    <div class="col">
                      <label class="form-label">{{$t('customerId')}}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="customerId"
                          :placeholder="$t('customerId')"
                          v-model="forms.customerId"
                          disabled
                        />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{
                          $t('warehouseId_txt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="warehouseId"
                          :placeholder="$t('warehouseId_txt')"
                          v-model="forms.warehouseId"
                          disabled
                        />
                    </div>
                  </div>
        
       
                  <div class="row mb-3">
                    <div class="col">
                      <label class="form-label">{{$t('rateName_txt')}}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="rateName"
                          :placeholder="$t('rateName_txt')"
                          v-model="forms.rateName"
                          disabled
                        />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{
                          $t('effectiveDate_txt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="effectiveDate"
                          :placeholder="$t('effectiveDate_txt')"
                          v-model="forms.effectiveDate"
                          disabled
                        />
                    </div>
                  </div>
   
       
                  <div class="row mb-3">
                    <div class="col">
                      <label class="form-label">{{$t('firstBilingDate_txt')}}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="firstBilingDate"
                          :placeholder="$t('firstBilingDate_txt')"
                          v-model="forms.firstBilingDate"
                          disabled
                        />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{
                          $t('statusTxt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="status"
                          :placeholder="$t('statusTxt')"
                          v-model="forms.status"
                          disabled
                        />
                    </div>
                  </div>


                  <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;
                      <button v-if="permision_role.method_create && forms.status == 'DISABLED'"
                        class="
                          btn btn-success
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="createDataDetail()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-plus"></i>
                        {{ $t("addDetail") }}
                      </button>
                       
                      &nbsp;&nbsp;
                      <button v-if="permision_role.method_update && forms.status == 'DISABLED'"
                        class="
                          btn btn-primary
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="editData()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-grease-pencil"></i>
                        {{ $t("editMess") }}
                      </button>
 
                   </div>

                  <div class="row mb-3">


                  <vue-good-table
                    title="list-billing-cli-rate-details"
                    :rows="rows"
                    :columns="columns"
                    :sort-options="{
                      enabled: true,
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                     <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read && forms.status == 'DISABLED'"
                              title="Detail"
                              @click.prevent="
                                detailDataDetail(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a>
                            <a
                              href="#"
                              v-if="permision_role.method_update && forms.status == 'DISABLED'"
                              title="Edit"
                              @click.prevent="editDataDetail(props.index, props.row)"
                            >
                              <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                              
                            </a>

                            <a
                              href="#"
                              v-if="permision_role.method_delete && forms.status == 'DISABLED'"
                              title="Delete"
                              @click.prevent="
                                deleteDataDetail(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                            </a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>


                  </div>

                    
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->


        <!--begin::modal-->

        <modal name="createBillingCliRateDetail" :draggable="true" :scredit_rate_detail_txtollable="true" :height="'auto'">
          <form class="forms-sample" @submit.prevent="submitData" method="POST">
            
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{this.$t("create_rate_detail_txt")}}</h5>
            <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
          </div>

          <div class="modal-body">
               

            <div class="mb-3">
              <label for="chargeCategory" class="form-label">{{this.$t("chargeCategory_txt")}}:</label>

              <v-select :options="fetchchargeCategory" v-model="chargeCategory" label="chargeType" return-object @search="asyncSearchchargeCategory">
                <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!chargeCategory"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              </v-select>

              <div v-if="errors.chargeCategory">
                <div
                  v-for="error in errors.chargeCategory"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
               

            <div class="mb-3">
              <label for="chargeType" class="form-label">{{this.$t("chargeType_txt")}}:</label>

              <v-select :options="fetchchargeType" v-model="chargeType" label="chargeType" return-object @search="asyncSearchchargeType">
                <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!chargeType"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              </v-select>

              <div v-if="errors.chargeType">
                <div
                  v-for="error in errors.chargeType"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
 
            <div class="mb-3">
              <label for="rateBase" class="form-label">{{this.$t("rateBase_txt")}}:</label>

              <v-select :options="fetchrateBase" v-model="rateBase" label="rateBase" return-object @search="asyncSearchrateBase"></v-select>
             
              <div v-if="errors.rateBase">
                <div
                  v-for="error in errors.rateBase"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
            
            <div class="mb-3">
                <label for="SAPMaterialCode" class="form-label">{{this.$t("SAPMaterialCode")}}:</label>
                <input type="text" class="form-control" id="SAPMaterialCode" :placeholder="$t('SAPMaterialCode')" v-model="rateBase.materialCode" disabled/>
                <div v-if="errors.SAPMaterialCode">
                  <div
                    v-for="error in errors.SAPMaterialCode"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            
              <div class="mb-3">
                <label for="SAPDivision" class="form-label">{{this.$t("SAPDivision")}}:</label>
                <input type="text" class="form-control" id="SAPDivision" :placeholder="$t('SAPDivision')" v-model="rateDetail.SAPDivision" @input="rateDetail.SAPDivision = $event.target.value.toUpperCase()" required/>
                <div v-if="errors.SAPDivision">
                  <div
                    v-for="error in errors.SAPDivision"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="tier" class="form-label">{{this.$t("tier")}}:</label>
                <input type="number" class="form-control" id="tier" :placeholder="$t('tier')" v-model="rateDetail.tier" required/>
                <div v-if="errors.tier">
                  <div
                    v-for="error in errors.tier"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="rateBase.categoryCode == 'HANDLING IN' || rateBase.categoryCode == 'HANDLING OUT'">
                <label for="tierQty" class="form-label">{{this.$t("tierQty")}}:</label>
                <input type="number" class="form-control" id="tierQty" :placeholder="$t('tierQty')" v-model="rateDetail.tierQty" required/>
                <div v-if="errors.tierQty">
                  <div
                    v-for="error in errors.tierQty"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="ratePerUnit" class="form-label">{{this.$t("ratePerUnit")}}:</label>
                <input type="number" class="form-control" id="ratePerUnit" :placeholder="$t('ratePerUnit')" v-model="rateDetail.ratePerUnit" required/>
                <div v-if="errors.ratePerUnit">
                  <div
                    v-for="error in errors.ratePerUnit"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="remark" class="form-label">{{this.$t("remark")}}:</label>
                <input type="text" class="form-control" id="remark" :placeholder="$t('remark')" v-model="rateDetail.remark" @input="rateDetail.remark = $event.target.value.toUpperCase()"/>
                <div v-if="errors.remark">
                  <div
                    v-for="error in errors.remark"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
            <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
          </div>

          </form>
        </modal>


        <modal name="detailBillingCliRateDetail" :draggable="true" :scrollable="true" :height="'auto'">
    
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{this.$t("detail_rate_detail_txt")}}</h5>
            <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
          </div>

          <div class="modal-body">
               

            <div class="mb-3">
              <label for="chargeCategory" class="form-label">{{this.$t("chargeCategory_txt")}}:</label>
              <input type="text" class="form-control" id="chargeCategory" :placeholder="$t('chargeCategory_txt')" v-model="rateDetail.chargeCategory" @input="rateDetail.chargeCategory = $event.target.value.toUpperCase()" disabled/>
              <div v-if="errors.chargeCategory">
                <div
                  v-for="error in errors.chargeCategory"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
               

            <div class="mb-3">
              <label for="chargeType" class="form-label">{{this.$t("chargeType_txt")}}:</label>
              <input type="text" class="form-control" id="chargeType" :placeholder="$t('chargeType_txt')" v-model="rateDetail.chargeType" @input="rateDetail.chargeType = $event.target.value.toUpperCase()" disabled/>
              <div v-if="errors.chargeType">
                <div
                  v-for="error in errors.chargeType"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
 
            <div class="mb-3">
              <label for="rateBase" class="form-label">{{this.$t("rateBase_txt")}}:</label>
              <input type="text" class="form-control" id="rateBase" :placeholder="$t('rateBase_txt')" v-model="rateDetail.rateBase" @input="rateDetail.rateBase = $event.target.value.toUpperCase()" disabled/>
              <div v-if="errors.rateBase">
                <div
                  v-for="error in errors.rateBase"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
            
            <div class="mb-3">
                <label for="SAPMaterialCode" class="form-label">{{this.$t("SAPMaterialCode")}}:</label>
                <input type="text" class="form-control" id="SAPMaterialCode" :placeholder="$t('SAPMaterialCode')" v-model="rateDetail.SAPMaterialCode" @input="rateDetail.SAPMaterialCode = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.SAPMaterialCode">
                  <div
                    v-for="error in errors.SAPMaterialCode"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            
              <div class="mb-3">
                <label for="SAPDivision" class="form-label">{{this.$t("SAPDivision")}}:</label>
                <input type="text" class="form-control" id="SAPDivision" :placeholder="$t('SAPDivision')" v-model="rateDetail.SAPDivision" @input="rateDetail.SAPDivision = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.SAPDivision">
                  <div
                    v-for="error in errors.SAPDivision"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="tier" class="form-label">{{this.$t("tier")}}:</label>
                <input type="number" class="form-control" id="tier" :placeholder="$t('tier')" v-model="rateDetail.tier" disabled/>
                <div v-if="errors.tier">
                  <div
                    v-for="error in errors.tier"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="rateDetail.chargeCategory == 'HANDLING IN' || rateDetail.chargeCategory == 'HANDLING OUT'">
                <label for="tierQty" class="form-label">{{this.$t("tierQty")}}:</label>
                <input type="number" class="form-control" id="tierQty" :placeholder="$t('tierQty')" v-model="rateDetail.tierQty" disabled/>
                <div v-if="errors.tierQty">
                  <div
                    v-for="error in errors.tierQty"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="ratePerUnit" class="form-label">{{this.$t("ratePerUnit")}}:</label>
                <input type="number" class="form-control" id="ratePerUnit" :placeholder="$t('ratePerUnit')" v-model="rateDetail.ratePerUnit" disabled/>
                <div v-if="errors.ratePerUnit">
                  <div
                    v-for="error in errors.ratePerUnit"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="remark" class="form-label">{{this.$t("remark")}}:</label>
                <input type="text" class="form-control" id="remark" :placeholder="$t('remark')" v-model="rateDetail.remark" @input="rateDetail.remark = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.remark">
                  <div
                    v-for="error in errors.remark"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="remark" class="form-label">{{this.$t("query")}}:</label>
                <textarea class="form-control" id="query" :placeholder="$t('query')" v-model="rateDetail.query_data" disabled></textarea>
                <div v-if="errors.query">
                  <div
                    v-for="error in errors.query"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="addwho" class="form-label">{{this.$t("addwho")}}:</label>
                <input type="text" class="form-control" id="addwho" :placeholder="$t('addwho')" v-model="rateDetail.addwho" @input="rateDetail.addwho = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.addwho">
                  <div
                    v-for="error in errors.addwho"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


              <div class="mb-3">
                <label for="adddate" class="form-label">{{this.$t("adddate")}}:</label>
                <input type="text" class="form-control" id="adddate" :placeholder="$t('adddate')" v-model="rateDetail.adddate" @input="rateDetail.adddate = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.adddate">
                  <div
                    v-for="error in errors.adddate"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


              <div class="mb-3">
                <label for="editwho" class="form-label">{{this.$t("editwho")}}:</label>
                <input type="text" class="form-control" id="editwho" :placeholder="$t('editwho')" v-model="rateDetail.editwho" @input="rateDetail.editwho = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.editwho">
                  <div
                    v-for="error in errors.editwho"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


              <div class="mb-3">
                <label for="editdate" class="form-label">{{this.$t("editdate")}}:</label>
                <input type="text" class="form-control" id="editdate" :placeholder="$t('editdate')" v-model="rateDetail.editdate" @input="rateDetail.editdate = $event.target.value.toUpperCase()" disabled/>
                <div v-if="errors.editdate">
                  <div
                    v-for="error in errors.editdate"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
          </div>
 
        </modal>



        <modal name="editBillingCliRateDetail" :draggable="true" :scrollable="true" :height="'auto'">
          <form class="forms-sample" @submit.prevent="submitDataEdit" method="POST">
            
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{this.$t("edit_rate_detail_txt")}}</h5>
            <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
          </div>

          <div class="modal-body">
               

            <div class="mb-3">
              <label for="chargeCategory" class="form-label">{{this.$t("chargeCategory_txt")}}:</label>

              <v-select :options="fetchchargeCategory" v-model="chargeCategory" label="chargeType" return-object @search="asyncSearchchargeCategory">
                <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!chargeCategory"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              </v-select>

              <div v-if="errors.chargeCategory">
                <div
                  v-for="error in errors.chargeCategory"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
               

            <div class="mb-3">
              <label for="chargeType" class="form-label">{{this.$t("chargeType_txt")}}:</label>

              <v-select :options="fetchchargeType" v-model="chargeType" label="chargeType" return-object @search="asyncSearchchargeType">
                <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!chargeType"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              </v-select>

              <div v-if="errors.chargeType">
                <div
                  v-for="error in errors.chargeType"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
 
            <div class="mb-3">
              <label for="rateBase" class="form-label">{{this.$t("rateBase_txt")}}:</label>

              <v-select :options="fetchrateBase" v-model="rateBase" label="rateBase" return-object @search="asyncSearchrateBase"></v-select>
             
              <div v-if="errors.rateBase">
                <div
                  v-for="error in errors.rateBase"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
            
            <div class="mb-3">
                <label for="SAPMaterialCode" class="form-label">{{this.$t("SAPMaterialCode")}}:</label>
                <input type="text" class="form-control" id="SAPMaterialCode" :placeholder="$t('SAPMaterialCode')" v-model="rateBase.materialCode" disabled/>
                <div v-if="errors.SAPMaterialCode">
                  <div
                    v-for="error in errors.SAPMaterialCode"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            
              <div class="mb-3">
                <label for="SAPDivision" class="form-label">{{this.$t("SAPDivision")}}:</label>
                <input type="text" class="form-control" id="SAPDivision" :placeholder="$t('SAPDivision')" v-model="rateDetail.SAPDivision" @input="rateDetail.SAPDivision = $event.target.value.toUpperCase()" required/>
                <div v-if="errors.SAPDivision">
                  <div
                    v-for="error in errors.SAPDivision"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="tier" class="form-label">{{this.$t("tier")}}:</label>
                <input type="number" class="form-control" id="tier" :placeholder="$t('tier')" v-model="rateDetail.tier" required/>
                <div v-if="errors.tier">
                  <div
                    v-for="error in errors.tier"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="rateBase.categoryCode == 'HANDLING IN' || rateBase.categoryCode == 'HANDLING OUT'">
                <label for="tierQty" class="form-label">{{this.$t("tierQty")}}:</label>
                <input type="number" class="form-control" id="tierQty" :placeholder="$t('tierQty')" v-model="rateDetail.tierQty" required/>
                <div v-if="errors.tierQty">
                  <div
                    v-for="error in errors.tierQty"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="ratePerUnit" class="form-label">{{this.$t("ratePerUnit")}}:</label>
                <input type="number" class="form-control" id="ratePerUnit" :placeholder="$t('ratePerUnit')" v-model="rateDetail.ratePerUnit" required/>
                <div v-if="errors.ratePerUnit">
                  <div
                    v-for="error in errors.ratePerUnit"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="remark" class="form-label">{{this.$t("remark")}}:</label>
                <input type="text" class="form-control" id="remark" :placeholder="$t('remark')" v-model="rateDetail.remark" @input="rateDetail.remark = $event.target.value.toUpperCase()"/>
                <div v-if="errors.remark">
                  <div
                    v-for="error in errors.remark"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>


          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
            <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
          </div>

          </form>
        </modal>
        <!--end::modal-->


        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CliRateHeaderDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      fetchchargeCategory:[],
      fetchchargeType:[],
      fetchrateBase:[],
      chargeCategory:"",
      chargeType:"",
      rateBase:"",
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      forms: { bm_rate_detail: [],effectiveDate:"", idRateHeader: "",rateName:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"", addwho:"",  editwho:""},
      rateDetail: { idRateDetail:"", idRateHeader: "",chargeCategory:"" , chargeType:"", rateBase:"", SAPMaterialCode:"", SAPDivision:"", tier:0, tierQty:0, ratePerUnit:0, remark:"", addwho:"",  editwho:"", adddate:"",  editdate:"",  query_data:""},
      columns: [
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeCategory_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rateBase_txt"),
          field: "rateBase",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rateBase_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPMaterialCode"),
          field: "SAPMaterialCode",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPMaterialCode_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPDivision"),
          field: "SAPDivision",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPDivision_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tier"),
          field: "tier",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tier_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tierQty"),
          field: "tierQty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tierQty_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
   
        {
          label: this.$t("ratePerUnit"),
          field: "ratePerUnit",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("ratePerUnit_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("remarks_txt"),
          field: "remark",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("remark_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


          {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            filterOptions: {
              customFilter: false,
              enabled: false, 
            },
          },
      ],
      rows: [],
    };
  },
  watch: {},
  methods: {


    asyncSearchrateBase(ev){
       
       if(typeof this.chargeCategory === 'object' && typeof this.chargeType === 'object') {
         let categoryCode = this.chargeCategory.chargeType
         let chargeType   = this.chargeType.chargeType
         const baseURI = this.$settings.endPointBilling + "dashboard/bm-codelkup/select?categoryCode="+categoryCode+"&chargeType="+chargeType+"&rateBase="+ev;
 
         return this.$http.get(baseURI).then((response) => {
           this.fetchrateBase = response.data.datas.data;
         });
 
       }
 
     },

    asyncSearchchargeType(ev){
       
      if(typeof this.chargeCategory === 'object') {
        let categoryCode = this.chargeCategory.chargeType
        const baseURI = this.$settings.endPointBilling + "dashboard/bm-codelkup/select?categoryCode="+categoryCode+"&chargeType="+ev;

        return this.$http.get(baseURI).then((response) => {
          this.fetchchargeType = response.data.datas.data;
        });

      }

    },

    asyncSearchchargeCategory(ev){
      const baseURI = this.$settings.endPointBilling + "dashboard/bm-codelkup/select?categoryCode=RATE_DROP_DOWN&chargeType="+ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchchargeCategory = response.data.datas.data;
      });
    },

    submitData() {
      this.isLoading = true;
            
      const baseURI  =  this.$settings.endPointBilling + "dashboard/cli-rate/bm-rate-detail-create";

      var params = this.$onBehind(this.$route.params.id);
      this.rateDetail.idRateHeader  = params[0]
      if(typeof this.rateBase === 'object') {
        this.rateDetail.chargeCategory  = this.rateBase.categoryCode
        this.rateDetail.chargeType      = this.rateBase.chargeType
        this.rateDetail.rateBase        = this.rateBase.rateBase
        this.rateDetail.SAPMaterialCode = this.rateBase.materialCode
        this.rateDetail.query_data      = this.rateBase.query
      }
 

      this.$http.post(baseURI,this.rateDetail,{ timeout: 10000 }).then((response) => {
          this.loading();
          if(response.data.status === 200) {
              this.isLoading = false;
              this.errors = [];
              this.removeModals()
              this.success('Successfully');
              var params = this.$onBehind(this.$route.params.id);
              this.loadData(params[0]);
          }else{
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
          }
      }).catch(error => {
            this.loading();
            this.isLoading = false;
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },


    submitDataEdit() {
      this.isLoading = true;
            
      const baseURI  =  this.$settings.endPointBilling + "dashboard/cli-rate/bm-rate-detail-update/"+this.rateDetail.idRateDetail;

      var params = this.$onBehind(this.$route.params.id);
      this.rateDetail.idRateHeader  = params[0]
      if(typeof this.rateBase === 'object') {
        this.rateDetail.chargeCategory  = this.rateBase.categoryCode
        this.rateDetail.chargeType      = this.rateBase.chargeType
        this.rateDetail.rateBase        = this.rateBase.rateBase
        this.rateDetail.SAPMaterialCode = this.rateBase.materialCode
        this.rateDetail.query_data      = this.rateBase.query
      }
 

      this.$http.patch(baseURI,this.rateDetail,{ timeout: 10000 }).then((response) => {
          this.loading();
          if(response.data.status === 200) {
              this.isLoading = false;
              this.errors = [];
              this.removeModals()
              this.success('Successfully');
              var params = this.$onBehind(this.$route.params.id);
              this.loadData(params[0]);
          }else{
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
          }
      }).catch(error => {
            this.loading();
            this.isLoading = false;
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

    deleteDataDetail(index, row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-rate/bm-rate-detail-delete/" + row.idRateDetail;
          this.$http
            .delete(baseURI, formData,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                var params = this.$onBehind(this.$route.params.id);
                this.loadData(params[0]);
                this.success(response.data.datas.messages);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{
          this.isLoading = false;
        }
      });
    },

    createDataDetail() {
      this.$modal.show('createBillingCliRateDetail')
    },

    editDataDetail(index,row) {
      this.rateDetail       = row;
      this.chargeCategory   = {chargeType:row.chargeCategory}
      this.chargeType       = {chargeType:row.chargeType}
      this.rateBase         = {categoryCode:row.chargeCategory,chargeType:row.chargeType,rateBase:row.rateBase,materialCode:row.SAPMaterialCode,query_data:row.query}
      this.$modal.show('editBillingCliRateDetail')
    },

    detailDataDetail(index,row) {
      this.rateDetail     = row;
      this.rateDetail.query_data      = row.query
      this.$modal.show('detailBillingCliRateDetail')
    },

    removeModals(){
      
      this.$modal.hide('createBillingCliRateDetail')
      this.$modal.hide('detailBillingCliRateDetail')
      this.$modal.hide('editBillingCliRateDetail')
      this.rateDetail.idRateDetail         = ""
      this.rateDetail.idRateHeader         = ""
      this.rateDetail.chargeCategory       = ""
      this.rateDetail.chargeType           = ""
      this.rateDetail.rateBase             = ""
      this.rateDetail.SAPMaterialCode      = ""
      this.rateDetail.SAPDivision          = ""
      this.rateDetail.tier                 = 0
      this.rateDetail.tierQty              = 0
      this.rateDetail.ratePerUnit          = 0
      this.rateDetail.remark               = ""
      this.rateDetail.adddate              = ""
      this.rateDetail.addwho               = ""
      this.rateDetail.editdate             = ""
      this.rateDetail.query_data           = ""
      this.rateDetail.editwho              = ""
      this.chargeCategory       = ""
      this.chargeType           = ""
      this.rateBase             = ""
      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);

    },


    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cli-rate/edit/" + params;
    },


    backForm() {
      window.location.href = "/billing-cli-rate";
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-rate/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
       this.isLoading = false;
        this.forms = response.data.datas;
        this.forms.effectiveDate  = response.data.datas.effectiveFromDate+"~"+response.data.datas.effectiveToDate
        this.rows   = response.data.datas.bm_rate_detail;
      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
    },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'RateCliController'){

          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },
 

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>

</style>